// tslint:disable: max-line-length
import React from "react";

import { IIconType } from "components/shared/icon_types/_prop_interface";

function MinusSign({ size, color, ...rest }: IIconType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 30 30"
      {...rest}>
      <path
        d="M15 1.93548C22.1747 1.93548 28.0645 7.74647 28.0645 15C28.0645 22.2152 22.2212 28.0645 15 28.0645C7.78766 28.0645 1.93548 22.2241 1.93548 15C1.93548 7.79014 7.77835 1.93548 15 1.93548ZM15 0C6.71631 0 0 6.71873 0 15C0 23.2861 6.71631 30 15 30C23.2837 30 30 23.2861 30 15C30 6.71873 23.2837 0 15 0ZM12.8226 20.8065H13.5484V13.5484H12.8226C12.4218 13.5484 12.0968 13.2234 12.0968 12.8226V12.3387C12.0968 11.9379 12.4218 11.6129 12.8226 11.6129H15.7258C16.1266 11.6129 16.4516 11.9379 16.4516 12.3387V20.8065H17.1774C17.5782 20.8065 17.9032 21.1314 17.9032 21.5323V22.0161C17.9032 22.417 17.5782 22.7419 17.1774 22.7419H12.8226C12.4218 22.7419 12.0968 22.417 12.0968 22.0161V21.5323C12.0968 21.1314 12.4218 20.8065 12.8226 20.8065ZM15 6.29032C13.9311 6.29032 13.0645 7.15687 13.0645 8.22581C13.0645 9.29474 13.9311 10.1613 15 10.1613C16.0689 10.1613 16.9355 9.29474 16.9355 8.22581C16.9355 7.15687 16.0689 6.29032 15 6.29032Z"
        fill={color}
      />
    </svg>
  );
}

export default MinusSign;
